import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Tutorials.module.css';
import StarMap from './StarMap';
import { ConstellationData } from './Constellation';
import TutorialProgressService from './TutorialProgressService';
import GlobalHeader from '../GlobalHeader';
import AdSenseLayout from '../AdSense/AdSenseLayout';
import { playUISound } from '../../utils/UISoundEffects';

function Tutorials() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleConstellationClick = (constellation: ConstellationData) => {
    // Here you can navigate to specific tutorials or show constellation details
    // Example: navigate to tutorial for this constellation
  };

  useEffect(() => {
    // Set dark background for the entire page
    document.body.style.backgroundColor = '#0a0a0d';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    
    // Cleanup function to restore original styles when component unmounts
    return () => {
      document.body.style.backgroundColor = '';
      document.body.style.margin = '';
      document.body.style.padding = '';
    };
  }, []);

  return (
    <AdSenseLayout>
      <div className={styles.container}>
        <GlobalHeader />
      
      {/* Home button - top left */}
      <button onClick={() => { playUISound(); handleGoHome(); }} className={styles.homeBackButton}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
      </button>

      {/* Star field background (your existing twinkling stars) */}
      
      {/* Constellation overlay */}
      <StarMap onConstellationClick={handleConstellationClick} />
      </div>
    </AdSenseLayout>
  );
}

export default Tutorials; 
